import React from 'react';
import { connect } from 'react-redux';
import moment from "moment/moment";

import Translate from 'translate';
import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import NetworkService from 'services/NetworkService';
import ConfigurationService from "services/ConfigurationService";
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import LogDetail from '../LogDetail';

class NetworksList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      logDetailModalOpened: false,
    };
    this.logEntity = {};
  }

  getLogs = ( params, cb ) => {
    const { toggleLoading, type } = this.props;
    this.paramsLogs = params;

    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    apiParams[`filters[origin]`] = type.toLowerCase();
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';

    ConfigurationService.getLogs( apiParams ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  };

  toggleLogDetailModal = ( item ) => {
    this.logEntity = item;
    this.setState( { logDetailModalOpened: !this.state.logDetailModalOpened } )
  };

  render() {
    const { data, logDetailModalOpened, ...rest } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header d-flex justify-content-between">
            <span className="text-capitalize"><Translate id="logs"/></span>
            <div>
              <button className="btn btn-info" onClick={() => this.getLogs( this.paramsLogs )}>
                <Translate id="reload"/>
              </button>
            </div>
          </div>

          <div className="box-body">
            <AsyncTable className="app-table-white"
                        onFetchData={this.getLogs}
                        rowsText="Logs"
                        data={data}
                        {...rest}
                        columns={[
                          { Header: <Translate id="action"/>, accessor: 'action', maxWidth: 80 },
                          { Header: <Translate id="url"/>, accessor: 'url' },
                          { Header: <Translate id="statusResponse"/>, accessor: 'statusResponse', maxWidth: 120 },
                          { Header: <Translate id="response"/>, accessor: 'response' },
                          {
                            Header: <Translate id="createdAt"/>, accessor: 'createdAt',
                            Cell: props => moment( props.value ).format( 'DD/MM/YYYY hh:mm A' )
                          },
                        ]}
                        getTdProps={( state, rowInfo ) => {
                          return {
                            onClick: ( e, handleOriginal ) => {
                              this.toggleLogDetailModal( rowInfo.original );
                              if( handleOriginal ) {
                                handleOriginal()
                              }
                            }
                          }
                        }}/>
          </div>
        </div>

        <LogDetail open={logDetailModalOpened}
                   data={this.logEntity}
                   onClose={this.toggleLogDetailModal}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( NetworksList );




// WEBPACK FOOTER //
// ./routes/app/components/Management/NetworkList/index.js